import React from 'react';
import { useTranslation } from "react-i18next";
import Card from "react-bootstrap/Card";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";

const Conditions = () => {
   const { t, i18n } = useTranslation();
   const basePath = i18n.language === "en" ? "/en" : "";
    return (
       <div className="policy-conditions">
          <Helmet>
             <title>Términos y condiciones | Joan Company</title>
             <meta
                name="description"
                content="Consulta los términos y condiciones de los servicios de grabación y fotografía aérea con drones."
             />
             <link
                rel="alternate"
                href="https://www.joancompany.es/condiciones"
                hreflang="es"
             />
             <link
                rel="alternate"
                href="https://www.joancompany.es/en/condiciones"
                hreflang="en"
             />
          </Helmet>
          <div className="policy-conditions-container">
             <h1>{t("terms_and_conditions")}</h1>
             <h2>{t("last_update")}</h2>
          </div>
          <div className="page-breadcrumb">
             <Link to={`${basePath}/`} title="Home">
                {t("home")}
             </Link>
             <span>/</span>
             <span>{t("terms_and_conditions")}</span>
          </div>
          <Card
             className="quote-card-view"
             id="service-info-card"
             data-aos="fade-up"
             data-aos-duration="2000"
          >
             <Card.Body>
                <div className="policy-conditions-content">
                   <div
                      dangerouslySetInnerHTML={{
                         __html: t("conditions_content"),
                      }}
                   />
                </div>
             </Card.Body>
          </Card>
       </div>
    );
};

export default Conditions;